export default __webpack_public_path__ + "static/media/Schulung Passwortschutz.3bd9cbb5.jpg";